// @generated by protoc-gen-es v1.8.0 with parameter "target=ts"
// @generated from file gitpod/v1/runner_manager.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { Subject } from "./identity_pb.js";
import { LogLevel } from "./runner_pb.js";
import { LLMIntegrationRequestHeader, SCMIntegrationOAuthConfig } from "./runner_configuration_pb.js";
import { SupportedModel } from "./agent_pb.js";
import { PaginationRequest, PaginationResponse } from "./pagination_pb.js";

/**
 * @generated from enum gitpod.v1.RunnerManagerPhase
 */
export enum RunnerManagerPhase {
  /**
   * @generated from enum value: RUNNER_MANAGER_PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RUNNER_MANAGER_PHASE_CREATED = 1;
   */
  CREATED = 1,

  /**
   * @generated from enum value: RUNNER_MANAGER_PHASE_ENABLED = 2;
   */
  ENABLED = 2,

  /**
   * @generated from enum value: RUNNER_MANAGER_PHASE_DISABLED = 3;
   */
  DISABLED = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(RunnerManagerPhase)
proto3.util.setEnumType(RunnerManagerPhase, "gitpod.v1.RunnerManagerPhase", [
  { no: 0, name: "RUNNER_MANAGER_PHASE_UNSPECIFIED" },
  { no: 1, name: "RUNNER_MANAGER_PHASE_CREATED" },
  { no: 2, name: "RUNNER_MANAGER_PHASE_ENABLED" },
  { no: 3, name: "RUNNER_MANAGER_PHASE_DISABLED" },
]);

/**
 * @generated from enum gitpod.v1.RunnerManagerReleaseChannel
 */
export enum RunnerManagerReleaseChannel {
  /**
   * @generated from enum value: RUNNER_MANAGER_RELEASE_CHANNEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RUNNER_MANAGER_RELEASE_CHANNEL_STABLE = 1;
   */
  STABLE = 1,

  /**
   * @generated from enum value: RUNNER_MANAGER_RELEASE_CHANNEL_LATEST = 2;
   */
  LATEST = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(RunnerManagerReleaseChannel)
proto3.util.setEnumType(RunnerManagerReleaseChannel, "gitpod.v1.RunnerManagerReleaseChannel", [
  { no: 0, name: "RUNNER_MANAGER_RELEASE_CHANNEL_UNSPECIFIED" },
  { no: 1, name: "RUNNER_MANAGER_RELEASE_CHANNEL_STABLE" },
  { no: 2, name: "RUNNER_MANAGER_RELEASE_CHANNEL_LATEST" },
]);

/**
 * @generated from message gitpod.v1.RunnerManager
 */
export class RunnerManager extends Message<RunnerManager> {
  /**
   * @generated from field: string runner_manager_id = 1;
   */
  runnerManagerId = "";

  /**
   * Time when the RunnerManager was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 2;
   */
  createdAt?: Timestamp;

  /**
   * Time when the RunnerManager was last updated.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 3;
   */
  updatedAt?: Timestamp;

  /**
   * The runner manager's name which is shown to users
   *
   * @generated from field: string name = 4;
   */
  name = "";

  /**
   * Region where the runner manager operates
   *
   * @generated from field: string region = 5;
   */
  region = "";

  /**
   * The runner manager's configuration (DEPRECATED: Use spec.configuration instead)
   *
   * @generated from field: gitpod.v1.RunnerManagerConfiguration configuration = 6 [deprecated = true];
   * @deprecated
   */
  configuration?: RunnerManagerConfiguration;

  /**
   * creator is the identity of the creator of the runner manager
   *
   * @generated from field: gitpod.v1.Subject creator = 7;
   */
  creator?: Subject;

  /**
   * The runner manager's specification
   *
   * @generated from field: gitpod.v1.RunnerManagerSpec spec = 8;
   */
  spec?: RunnerManagerSpec;

  /**
   * The current phase of the runner manager
   *
   * @generated from field: gitpod.v1.RunnerManagerPhase phase = 9 [deprecated = true];
   * @deprecated
   */
  phase = RunnerManagerPhase.UNSPECIFIED;

  /**
   * The current status of the runner manager
   *
   * @generated from field: gitpod.v1.RunnerManagerStatus status = 10;
   */
  status?: RunnerManagerStatus;

  constructor(data?: PartialMessage<RunnerManager>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RunnerManager";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_manager_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "created_at", kind: "message", T: Timestamp },
    { no: 3, name: "updated_at", kind: "message", T: Timestamp },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "region", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "configuration", kind: "message", T: RunnerManagerConfiguration },
    { no: 7, name: "creator", kind: "message", T: Subject },
    { no: 8, name: "spec", kind: "message", T: RunnerManagerSpec },
    { no: 9, name: "phase", kind: "enum", T: proto3.getEnumType(RunnerManagerPhase) },
    { no: 10, name: "status", kind: "message", T: RunnerManagerStatus },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RunnerManager {
    return new RunnerManager().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RunnerManager {
    return new RunnerManager().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RunnerManager {
    return new RunnerManager().fromJsonString(jsonString, options);
  }

  static equals(a: RunnerManager | PlainMessage<RunnerManager> | undefined, b: RunnerManager | PlainMessage<RunnerManager> | undefined): boolean {
    return proto3.util.equals(RunnerManager, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateRunnerManagerRequest
 */
export class CreateRunnerManagerRequest extends Message<CreateRunnerManagerRequest> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: string region = 2;
   */
  region = "";

  /**
   * @generated from field: gitpod.v1.RunnerManagerConfiguration configuration = 3;
   */
  configuration?: RunnerManagerConfiguration;

  constructor(data?: PartialMessage<CreateRunnerManagerRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateRunnerManagerRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "region", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "configuration", kind: "message", T: RunnerManagerConfiguration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateRunnerManagerRequest {
    return new CreateRunnerManagerRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateRunnerManagerRequest {
    return new CreateRunnerManagerRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateRunnerManagerRequest {
    return new CreateRunnerManagerRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateRunnerManagerRequest | PlainMessage<CreateRunnerManagerRequest> | undefined, b: CreateRunnerManagerRequest | PlainMessage<CreateRunnerManagerRequest> | undefined): boolean {
    return proto3.util.equals(CreateRunnerManagerRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateRunnerManagerResponse
 */
export class CreateRunnerManagerResponse extends Message<CreateRunnerManagerResponse> {
  /**
   * @generated from field: gitpod.v1.RunnerManager runner_manager = 1;
   */
  runnerManager?: RunnerManager;

  /**
   * @generated from field: string access_token = 2;
   */
  accessToken = "";

  constructor(data?: PartialMessage<CreateRunnerManagerResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateRunnerManagerResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_manager", kind: "message", T: RunnerManager },
    { no: 2, name: "access_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateRunnerManagerResponse {
    return new CreateRunnerManagerResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateRunnerManagerResponse {
    return new CreateRunnerManagerResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateRunnerManagerResponse {
    return new CreateRunnerManagerResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateRunnerManagerResponse | PlainMessage<CreateRunnerManagerResponse> | undefined, b: CreateRunnerManagerResponse | PlainMessage<CreateRunnerManagerResponse> | undefined): boolean {
    return proto3.util.equals(CreateRunnerManagerResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetRunnerManagerRequest
 */
export class GetRunnerManagerRequest extends Message<GetRunnerManagerRequest> {
  /**
   * @generated from field: string runner_manager_id = 1;
   */
  runnerManagerId = "";

  constructor(data?: PartialMessage<GetRunnerManagerRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetRunnerManagerRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_manager_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRunnerManagerRequest {
    return new GetRunnerManagerRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRunnerManagerRequest {
    return new GetRunnerManagerRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRunnerManagerRequest {
    return new GetRunnerManagerRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetRunnerManagerRequest | PlainMessage<GetRunnerManagerRequest> | undefined, b: GetRunnerManagerRequest | PlainMessage<GetRunnerManagerRequest> | undefined): boolean {
    return proto3.util.equals(GetRunnerManagerRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetRunnerManagerResponse
 */
export class GetRunnerManagerResponse extends Message<GetRunnerManagerResponse> {
  /**
   * @generated from field: gitpod.v1.RunnerManager runner_manager = 1;
   */
  runnerManager?: RunnerManager;

  constructor(data?: PartialMessage<GetRunnerManagerResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetRunnerManagerResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_manager", kind: "message", T: RunnerManager },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRunnerManagerResponse {
    return new GetRunnerManagerResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRunnerManagerResponse {
    return new GetRunnerManagerResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRunnerManagerResponse {
    return new GetRunnerManagerResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetRunnerManagerResponse | PlainMessage<GetRunnerManagerResponse> | undefined, b: GetRunnerManagerResponse | PlainMessage<GetRunnerManagerResponse> | undefined): boolean {
    return proto3.util.equals(GetRunnerManagerResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.RunnerManagerSpec
 */
export class RunnerManagerSpec extends Message<RunnerManagerSpec> {
  /**
   * @generated from field: gitpod.v1.RunnerManagerConfiguration configuration = 1;
   */
  configuration?: RunnerManagerConfiguration;

  /**
   * The desired phase for the runner manager
   *
   * @generated from field: gitpod.v1.RunnerManagerPhase desired_phase = 2;
   */
  desiredPhase = RunnerManagerPhase.UNSPECIFIED;

  constructor(data?: PartialMessage<RunnerManagerSpec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RunnerManagerSpec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "configuration", kind: "message", T: RunnerManagerConfiguration },
    { no: 2, name: "desired_phase", kind: "enum", T: proto3.getEnumType(RunnerManagerPhase) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RunnerManagerSpec {
    return new RunnerManagerSpec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RunnerManagerSpec {
    return new RunnerManagerSpec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RunnerManagerSpec {
    return new RunnerManagerSpec().fromJsonString(jsonString, options);
  }

  static equals(a: RunnerManagerSpec | PlainMessage<RunnerManagerSpec> | undefined, b: RunnerManagerSpec | PlainMessage<RunnerManagerSpec> | undefined): boolean {
    return proto3.util.equals(RunnerManagerSpec, a, b);
  }
}

/**
 * @generated from message gitpod.v1.RunnerManagerStatus
 */
export class RunnerManagerStatus extends Message<RunnerManagerStatus> {
  /**
   * The actual phase of the runner manager as reported by the system
   *
   * @generated from field: gitpod.v1.RunnerManagerPhase phase = 1;
   */
  phase = RunnerManagerPhase.UNSPECIFIED;

  constructor(data?: PartialMessage<RunnerManagerStatus>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RunnerManagerStatus";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "phase", kind: "enum", T: proto3.getEnumType(RunnerManagerPhase) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RunnerManagerStatus {
    return new RunnerManagerStatus().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RunnerManagerStatus {
    return new RunnerManagerStatus().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RunnerManagerStatus {
    return new RunnerManagerStatus().fromJsonString(jsonString, options);
  }

  static equals(a: RunnerManagerStatus | PlainMessage<RunnerManagerStatus> | undefined, b: RunnerManagerStatus | PlainMessage<RunnerManagerStatus> | undefined): boolean {
    return proto3.util.equals(RunnerManagerStatus, a, b);
  }
}

/**
 * @generated from message gitpod.v1.RunnerManagerConfiguration
 */
export class RunnerManagerConfiguration extends Message<RunnerManagerConfiguration> {
  /**
   * @generated from field: repeated gitpod.v1.StaticSCMIntegration scm_integration_templates = 1;
   */
  scmIntegrationTemplates: StaticSCMIntegration[] = [];

  /**
   * metrics contains configuration for the runner manager's metrics collection
   *
   * @generated from field: gitpod.v1.RunnerManagerMetricsConfiguration metrics = 2;
   */
  metrics?: RunnerManagerMetricsConfiguration;

  /**
   * log_level is the log level for the runner manager
   *
   * @generated from field: gitpod.v1.LogLevel log_level = 3;
   */
  logLevel = LogLevel.UNSPECIFIED;

  /**
   * @generated from field: repeated gitpod.v1.StaticLLMIntegration llm_integration_templates = 4;
   */
  llmIntegrationTemplates: StaticLLMIntegration[] = [];

  /**
   * The release channel for the runner manager
   *
   * @generated from field: gitpod.v1.RunnerManagerReleaseChannel release_channel = 5;
   */
  releaseChannel = RunnerManagerReleaseChannel.UNSPECIFIED;

  /**
   * When set to true, the runner manager collects pprof profiles and uploads
   * them to the logs S3 bucket. The runner manager resets this flag after
   * collection so it acts as a one-shot trigger.
   *
   * @generated from field: bool collect_debug_profile = 6;
   */
  collectDebugProfile = false;

  constructor(data?: PartialMessage<RunnerManagerConfiguration>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RunnerManagerConfiguration";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "scm_integration_templates", kind: "message", T: StaticSCMIntegration, repeated: true },
    { no: 2, name: "metrics", kind: "message", T: RunnerManagerMetricsConfiguration },
    { no: 3, name: "log_level", kind: "enum", T: proto3.getEnumType(LogLevel) },
    { no: 4, name: "llm_integration_templates", kind: "message", T: StaticLLMIntegration, repeated: true },
    { no: 5, name: "release_channel", kind: "enum", T: proto3.getEnumType(RunnerManagerReleaseChannel) },
    { no: 6, name: "collect_debug_profile", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RunnerManagerConfiguration {
    return new RunnerManagerConfiguration().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RunnerManagerConfiguration {
    return new RunnerManagerConfiguration().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RunnerManagerConfiguration {
    return new RunnerManagerConfiguration().fromJsonString(jsonString, options);
  }

  static equals(a: RunnerManagerConfiguration | PlainMessage<RunnerManagerConfiguration> | undefined, b: RunnerManagerConfiguration | PlainMessage<RunnerManagerConfiguration> | undefined): boolean {
    return proto3.util.equals(RunnerManagerConfiguration, a, b);
  }
}

/**
 * @generated from message gitpod.v1.StaticSCMIntegration
 */
export class StaticSCMIntegration extends Message<StaticSCMIntegration> {
  /**
   * @generated from field: string scm_id = 1;
   */
  scmId = "";

  /**
   * @generated from field: string host = 2;
   */
  host = "";

  /**
   * @generated from field: gitpod.v1.SCMIntegrationOAuthConfig oauth = 3;
   */
  oauth?: SCMIntegrationOAuthConfig;

  /**
   * @generated from field: bool pat = 4;
   */
  pat = false;

  /**
   * virtual_directory is the virtual directory path for Azure DevOps Server (e.g., "/tfs").
   * This field is only used for Azure DevOps Server SCM integrations and should be empty for other SCM types.
   * Azure DevOps Server APIs work without collection when PAT scope is 'All accessible organizations'.
   *
   * @generated from field: optional string virtual_directory = 5;
   */
  virtualDirectory?: string;

  constructor(data?: PartialMessage<StaticSCMIntegration>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.StaticSCMIntegration";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "scm_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "oauth", kind: "message", T: SCMIntegrationOAuthConfig },
    { no: 4, name: "pat", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "virtual_directory", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StaticSCMIntegration {
    return new StaticSCMIntegration().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StaticSCMIntegration {
    return new StaticSCMIntegration().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StaticSCMIntegration {
    return new StaticSCMIntegration().fromJsonString(jsonString, options);
  }

  static equals(a: StaticSCMIntegration | PlainMessage<StaticSCMIntegration> | undefined, b: StaticSCMIntegration | PlainMessage<StaticSCMIntegration> | undefined): boolean {
    return proto3.util.equals(StaticSCMIntegration, a, b);
  }
}

/**
 * @generated from message gitpod.v1.StaticLLMIntegration
 */
export class StaticLLMIntegration extends Message<StaticLLMIntegration> {
  /**
   * id is a unique identifier for the LLM integration template.
   * This field must be provided by the client when creating the integration.
   * It is required for identifying and updating the integration, since there is no other unique identifier.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * models represents the LLM models this integration supports
   *
   * @generated from field: repeated gitpod.v1.SupportedModel models = 2;
   */
  models: SupportedModel[] = [];

  /**
   * @generated from field: string endpoint = 3;
   */
  endpoint = "";

  /**
   * encrypted_api_key is the LLM provider's API key encrypted with the runner's public key.
   *
   * @generated from field: bytes encrypted_api_key = 4;
   */
  encryptedApiKey = new Uint8Array(0);

  /**
   * max_tokens is the maximum number of tokens to generate before stopping. 0 is a model default.
   *
   * @generated from field: uint64 max_tokens = 5;
   */
  maxTokens = protoInt64.zero;

  /**
   * request_headers contains custom request headers for this integration (e.g., for portkey compatibility).
   * Header values will be encrypted with the runner's public key.
   *
   * @generated from field: repeated gitpod.v1.LLMIntegrationRequestHeader request_headers = 6;
   */
  requestHeaders: LLMIntegrationRequestHeader[] = [];

  constructor(data?: PartialMessage<StaticLLMIntegration>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.StaticLLMIntegration";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "models", kind: "enum", T: proto3.getEnumType(SupportedModel), repeated: true },
    { no: 3, name: "endpoint", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "encrypted_api_key", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 5, name: "max_tokens", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 6, name: "request_headers", kind: "message", T: LLMIntegrationRequestHeader, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StaticLLMIntegration {
    return new StaticLLMIntegration().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StaticLLMIntegration {
    return new StaticLLMIntegration().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StaticLLMIntegration {
    return new StaticLLMIntegration().fromJsonString(jsonString, options);
  }

  static equals(a: StaticLLMIntegration | PlainMessage<StaticLLMIntegration> | undefined, b: StaticLLMIntegration | PlainMessage<StaticLLMIntegration> | undefined): boolean {
    return proto3.util.equals(StaticLLMIntegration, a, b);
  }
}

/**
 * @generated from message gitpod.v1.RunnerManagerMetricsConfiguration
 */
export class RunnerManagerMetricsConfiguration extends Message<RunnerManagerMetricsConfiguration> {
  /**
   * enabled indicates whether the runner should collect metrics
   *
   * @generated from field: bool enabled = 1;
   */
  enabled = false;

  /**
   * url is the URL of the metrics collector
   *
   * @generated from field: string url = 2;
   */
  url = "";

  /**
   * username is the username to use for the metrics collector
   *
   * @generated from field: string username = 3;
   */
  username = "";

  /**
   * password is the password to use for the metrics collector
   *
   * @generated from field: string password = 4;
   */
  password = "";

  constructor(data?: PartialMessage<RunnerManagerMetricsConfiguration>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RunnerManagerMetricsConfiguration";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RunnerManagerMetricsConfiguration {
    return new RunnerManagerMetricsConfiguration().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RunnerManagerMetricsConfiguration {
    return new RunnerManagerMetricsConfiguration().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RunnerManagerMetricsConfiguration {
    return new RunnerManagerMetricsConfiguration().fromJsonString(jsonString, options);
  }

  static equals(a: RunnerManagerMetricsConfiguration | PlainMessage<RunnerManagerMetricsConfiguration> | undefined, b: RunnerManagerMetricsConfiguration | PlainMessage<RunnerManagerMetricsConfiguration> | undefined): boolean {
    return proto3.util.equals(RunnerManagerMetricsConfiguration, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateRunnerManagerRequest
 */
export class UpdateRunnerManagerRequest extends Message<UpdateRunnerManagerRequest> {
  /**
   * runner_manager_id specifies which runner manager to be updated.
   *
   * +required
   *
   * @generated from field: string runner_manager_id = 1;
   */
  runnerManagerId = "";

  /**
   * The runner manager's name which is shown to users
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * Region where the runner manager operates
   *
   * @generated from field: optional string region = 3;
   */
  region?: string;

  /**
   * @generated from field: optional gitpod.v1.UpdateRunnerManagerRequest.Spec spec = 5;
   */
  spec?: UpdateRunnerManagerRequest_Spec;

  constructor(data?: PartialMessage<UpdateRunnerManagerRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateRunnerManagerRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_manager_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "region", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "spec", kind: "message", T: UpdateRunnerManagerRequest_Spec, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRunnerManagerRequest {
    return new UpdateRunnerManagerRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRunnerManagerRequest {
    return new UpdateRunnerManagerRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRunnerManagerRequest {
    return new UpdateRunnerManagerRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRunnerManagerRequest | PlainMessage<UpdateRunnerManagerRequest> | undefined, b: UpdateRunnerManagerRequest | PlainMessage<UpdateRunnerManagerRequest> | undefined): boolean {
    return proto3.util.equals(UpdateRunnerManagerRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerConfiguration
 */
export class UpdateRunnerManagerRequest_RunnerManagerConfiguration extends Message<UpdateRunnerManagerRequest_RunnerManagerConfiguration> {
  /**
   * scm_integration_templates_update contains the new values for the SCM integration templates.
   * when set, the runner manager's SCM integration templates will be replaced with the new templates.
   *
   * @generated from field: optional gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerConfiguration.StaticSCMIntegrationsUpdate scm_integration_templates_update = 1;
   */
  scmIntegrationTemplatesUpdate?: UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticSCMIntegrationsUpdate;

  /**
   * metrics contains configuration for the runner manager's metrics collection
   *
   * @generated from field: optional gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerMetricsConfiguration metrics = 2;
   */
  metrics?: UpdateRunnerManagerRequest_RunnerManagerMetricsConfiguration;

  /**
   * log_level is the log level for the runner manager
   *
   * @generated from field: optional gitpod.v1.LogLevel log_level = 3;
   */
  logLevel?: LogLevel;

  /**
   * llm_integration_templates_update contains the new values for the LLM integration templates.
   * when set, the runner manager's LLM integration templates will be replaced with the new templates.
   *
   * @generated from field: optional gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerConfiguration.StaticLLMIntegrationsUpdate llm_integration_templates_update = 4;
   */
  llmIntegrationTemplatesUpdate?: UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticLLMIntegrationsUpdate;

  /**
   * release_channel can be updated to control the runner manager release channel
   *
   * @generated from field: optional gitpod.v1.RunnerManagerReleaseChannel release_channel = 5;
   */
  releaseChannel?: RunnerManagerReleaseChannel;

  /**
   * When set to true, triggers a one-shot profile collection that uploads
   * pprof profiles to the logs S3 bucket.
   *
   * @generated from field: optional bool collect_debug_profile = 6;
   */
  collectDebugProfile?: boolean;

  constructor(data?: PartialMessage<UpdateRunnerManagerRequest_RunnerManagerConfiguration>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerConfiguration";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "scm_integration_templates_update", kind: "message", T: UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticSCMIntegrationsUpdate, opt: true },
    { no: 2, name: "metrics", kind: "message", T: UpdateRunnerManagerRequest_RunnerManagerMetricsConfiguration, opt: true },
    { no: 3, name: "log_level", kind: "enum", T: proto3.getEnumType(LogLevel), opt: true },
    { no: 4, name: "llm_integration_templates_update", kind: "message", T: UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticLLMIntegrationsUpdate, opt: true },
    { no: 5, name: "release_channel", kind: "enum", T: proto3.getEnumType(RunnerManagerReleaseChannel), opt: true },
    { no: 6, name: "collect_debug_profile", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRunnerManagerRequest_RunnerManagerConfiguration {
    return new UpdateRunnerManagerRequest_RunnerManagerConfiguration().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRunnerManagerRequest_RunnerManagerConfiguration {
    return new UpdateRunnerManagerRequest_RunnerManagerConfiguration().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRunnerManagerRequest_RunnerManagerConfiguration {
    return new UpdateRunnerManagerRequest_RunnerManagerConfiguration().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRunnerManagerRequest_RunnerManagerConfiguration | PlainMessage<UpdateRunnerManagerRequest_RunnerManagerConfiguration> | undefined, b: UpdateRunnerManagerRequest_RunnerManagerConfiguration | PlainMessage<UpdateRunnerManagerRequest_RunnerManagerConfiguration> | undefined): boolean {
    return proto3.util.equals(UpdateRunnerManagerRequest_RunnerManagerConfiguration, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerConfiguration.StaticSCMIntegrationsUpdate
 */
export class UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticSCMIntegrationsUpdate extends Message<UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticSCMIntegrationsUpdate> {
  /**
   * @generated from field: repeated gitpod.v1.StaticSCMIntegration scm_integration_templates = 1;
   */
  scmIntegrationTemplates: StaticSCMIntegration[] = [];

  constructor(data?: PartialMessage<UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticSCMIntegrationsUpdate>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerConfiguration.StaticSCMIntegrationsUpdate";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "scm_integration_templates", kind: "message", T: StaticSCMIntegration, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticSCMIntegrationsUpdate {
    return new UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticSCMIntegrationsUpdate().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticSCMIntegrationsUpdate {
    return new UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticSCMIntegrationsUpdate().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticSCMIntegrationsUpdate {
    return new UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticSCMIntegrationsUpdate().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticSCMIntegrationsUpdate | PlainMessage<UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticSCMIntegrationsUpdate> | undefined, b: UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticSCMIntegrationsUpdate | PlainMessage<UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticSCMIntegrationsUpdate> | undefined): boolean {
    return proto3.util.equals(UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticSCMIntegrationsUpdate, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerConfiguration.StaticLLMIntegrationsUpdate
 */
export class UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticLLMIntegrationsUpdate extends Message<UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticLLMIntegrationsUpdate> {
  /**
   * @generated from field: repeated gitpod.v1.StaticLLMIntegration llm_integration_templates = 1;
   */
  llmIntegrationTemplates: StaticLLMIntegration[] = [];

  constructor(data?: PartialMessage<UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticLLMIntegrationsUpdate>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerConfiguration.StaticLLMIntegrationsUpdate";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "llm_integration_templates", kind: "message", T: StaticLLMIntegration, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticLLMIntegrationsUpdate {
    return new UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticLLMIntegrationsUpdate().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticLLMIntegrationsUpdate {
    return new UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticLLMIntegrationsUpdate().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticLLMIntegrationsUpdate {
    return new UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticLLMIntegrationsUpdate().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticLLMIntegrationsUpdate | PlainMessage<UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticLLMIntegrationsUpdate> | undefined, b: UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticLLMIntegrationsUpdate | PlainMessage<UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticLLMIntegrationsUpdate> | undefined): boolean {
    return proto3.util.equals(UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticLLMIntegrationsUpdate, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerMetricsConfiguration
 */
export class UpdateRunnerManagerRequest_RunnerManagerMetricsConfiguration extends Message<UpdateRunnerManagerRequest_RunnerManagerMetricsConfiguration> {
  /**
   * enabled indicates whether the runner manager should collect metrics
   *
   * @generated from field: optional bool enabled = 1;
   */
  enabled?: boolean;

  /**
   * url is the URL of the metrics collector
   *
   * @generated from field: optional string url = 2;
   */
  url?: string;

  /**
   * username is the username to use for the metrics collector
   *
   * @generated from field: optional string username = 3;
   */
  username?: string;

  /**
   * password is the password to use for the metrics collector
   *
   * @generated from field: optional string password = 4;
   */
  password?: string;

  constructor(data?: PartialMessage<UpdateRunnerManagerRequest_RunnerManagerMetricsConfiguration>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerMetricsConfiguration";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRunnerManagerRequest_RunnerManagerMetricsConfiguration {
    return new UpdateRunnerManagerRequest_RunnerManagerMetricsConfiguration().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRunnerManagerRequest_RunnerManagerMetricsConfiguration {
    return new UpdateRunnerManagerRequest_RunnerManagerMetricsConfiguration().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRunnerManagerRequest_RunnerManagerMetricsConfiguration {
    return new UpdateRunnerManagerRequest_RunnerManagerMetricsConfiguration().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRunnerManagerRequest_RunnerManagerMetricsConfiguration | PlainMessage<UpdateRunnerManagerRequest_RunnerManagerMetricsConfiguration> | undefined, b: UpdateRunnerManagerRequest_RunnerManagerMetricsConfiguration | PlainMessage<UpdateRunnerManagerRequest_RunnerManagerMetricsConfiguration> | undefined): boolean {
    return proto3.util.equals(UpdateRunnerManagerRequest_RunnerManagerMetricsConfiguration, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateRunnerManagerRequest.Spec
 */
export class UpdateRunnerManagerRequest_Spec extends Message<UpdateRunnerManagerRequest_Spec> {
  /**
   * @generated from field: optional gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerConfiguration configuration = 1;
   */
  configuration?: UpdateRunnerManagerRequest_RunnerManagerConfiguration;

  /**
   * desired_phase can be updated to control the runner manager state
   *
   * @generated from field: optional gitpod.v1.RunnerManagerPhase desired_phase = 2;
   */
  desiredPhase?: RunnerManagerPhase;

  constructor(data?: PartialMessage<UpdateRunnerManagerRequest_Spec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateRunnerManagerRequest.Spec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "configuration", kind: "message", T: UpdateRunnerManagerRequest_RunnerManagerConfiguration, opt: true },
    { no: 2, name: "desired_phase", kind: "enum", T: proto3.getEnumType(RunnerManagerPhase), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRunnerManagerRequest_Spec {
    return new UpdateRunnerManagerRequest_Spec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRunnerManagerRequest_Spec {
    return new UpdateRunnerManagerRequest_Spec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRunnerManagerRequest_Spec {
    return new UpdateRunnerManagerRequest_Spec().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRunnerManagerRequest_Spec | PlainMessage<UpdateRunnerManagerRequest_Spec> | undefined, b: UpdateRunnerManagerRequest_Spec | PlainMessage<UpdateRunnerManagerRequest_Spec> | undefined): boolean {
    return proto3.util.equals(UpdateRunnerManagerRequest_Spec, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateRunnerManagerResponse
 */
export class UpdateRunnerManagerResponse extends Message<UpdateRunnerManagerResponse> {
  constructor(data?: PartialMessage<UpdateRunnerManagerResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateRunnerManagerResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRunnerManagerResponse {
    return new UpdateRunnerManagerResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRunnerManagerResponse {
    return new UpdateRunnerManagerResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRunnerManagerResponse {
    return new UpdateRunnerManagerResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRunnerManagerResponse | PlainMessage<UpdateRunnerManagerResponse> | undefined, b: UpdateRunnerManagerResponse | PlainMessage<UpdateRunnerManagerResponse> | undefined): boolean {
    return proto3.util.equals(UpdateRunnerManagerResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteRunnerManagerRequest
 */
export class DeleteRunnerManagerRequest extends Message<DeleteRunnerManagerRequest> {
  /**
   * @generated from field: string runner_manager_id = 1;
   */
  runnerManagerId = "";

  constructor(data?: PartialMessage<DeleteRunnerManagerRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteRunnerManagerRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_manager_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteRunnerManagerRequest {
    return new DeleteRunnerManagerRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteRunnerManagerRequest {
    return new DeleteRunnerManagerRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteRunnerManagerRequest {
    return new DeleteRunnerManagerRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteRunnerManagerRequest | PlainMessage<DeleteRunnerManagerRequest> | undefined, b: DeleteRunnerManagerRequest | PlainMessage<DeleteRunnerManagerRequest> | undefined): boolean {
    return proto3.util.equals(DeleteRunnerManagerRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteRunnerManagerResponse
 */
export class DeleteRunnerManagerResponse extends Message<DeleteRunnerManagerResponse> {
  constructor(data?: PartialMessage<DeleteRunnerManagerResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteRunnerManagerResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteRunnerManagerResponse {
    return new DeleteRunnerManagerResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteRunnerManagerResponse {
    return new DeleteRunnerManagerResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteRunnerManagerResponse {
    return new DeleteRunnerManagerResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteRunnerManagerResponse | PlainMessage<DeleteRunnerManagerResponse> | undefined, b: DeleteRunnerManagerResponse | PlainMessage<DeleteRunnerManagerResponse> | undefined): boolean {
    return proto3.util.equals(DeleteRunnerManagerResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRunnerManagersRequest
 */
export class ListRunnerManagersRequest extends Message<ListRunnerManagersRequest> {
  /**
   * pagination contains the pagination options for listing runner managers
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  constructor(data?: PartialMessage<ListRunnerManagersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRunnerManagersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRunnerManagersRequest {
    return new ListRunnerManagersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRunnerManagersRequest {
    return new ListRunnerManagersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRunnerManagersRequest {
    return new ListRunnerManagersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListRunnerManagersRequest | PlainMessage<ListRunnerManagersRequest> | undefined, b: ListRunnerManagersRequest | PlainMessage<ListRunnerManagersRequest> | undefined): boolean {
    return proto3.util.equals(ListRunnerManagersRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRunnerManagersResponse
 */
export class ListRunnerManagersResponse extends Message<ListRunnerManagersResponse> {
  /**
   * pagination contains the pagination options for listing runner managers
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * The runner managers registered in the scope
   *
   * @generated from field: repeated gitpod.v1.RunnerManager runner_managers = 2;
   */
  runnerManagers: RunnerManager[] = [];

  constructor(data?: PartialMessage<ListRunnerManagersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRunnerManagersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "runner_managers", kind: "message", T: RunnerManager, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRunnerManagersResponse {
    return new ListRunnerManagersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRunnerManagersResponse {
    return new ListRunnerManagersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRunnerManagersResponse {
    return new ListRunnerManagersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListRunnerManagersResponse | PlainMessage<ListRunnerManagersResponse> | undefined, b: ListRunnerManagersResponse | PlainMessage<ListRunnerManagersResponse> | undefined): boolean {
    return proto3.util.equals(ListRunnerManagersResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListAvailableRunnerManagersRequest
 */
export class ListAvailableRunnerManagersRequest extends Message<ListAvailableRunnerManagersRequest> {
  /**
   * pagination contains the pagination options for listing available runner managers
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  constructor(data?: PartialMessage<ListAvailableRunnerManagersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListAvailableRunnerManagersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAvailableRunnerManagersRequest {
    return new ListAvailableRunnerManagersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAvailableRunnerManagersRequest {
    return new ListAvailableRunnerManagersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAvailableRunnerManagersRequest {
    return new ListAvailableRunnerManagersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListAvailableRunnerManagersRequest | PlainMessage<ListAvailableRunnerManagersRequest> | undefined, b: ListAvailableRunnerManagersRequest | PlainMessage<ListAvailableRunnerManagersRequest> | undefined): boolean {
    return proto3.util.equals(ListAvailableRunnerManagersRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListAvailableRunnerManagersResponse
 */
export class ListAvailableRunnerManagersResponse extends Message<ListAvailableRunnerManagersResponse> {
  /**
   * pagination contains the pagination options for listing available runner managers
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * The runner managers available for the organization
   *
   * @generated from field: repeated gitpod.v1.AvailableRunnerManager runner_managers = 2;
   */
  runnerManagers: AvailableRunnerManager[] = [];

  constructor(data?: PartialMessage<ListAvailableRunnerManagersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListAvailableRunnerManagersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "runner_managers", kind: "message", T: AvailableRunnerManager, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAvailableRunnerManagersResponse {
    return new ListAvailableRunnerManagersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAvailableRunnerManagersResponse {
    return new ListAvailableRunnerManagersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAvailableRunnerManagersResponse {
    return new ListAvailableRunnerManagersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListAvailableRunnerManagersResponse | PlainMessage<ListAvailableRunnerManagersResponse> | undefined, b: ListAvailableRunnerManagersResponse | PlainMessage<ListAvailableRunnerManagersResponse> | undefined): boolean {
    return proto3.util.equals(ListAvailableRunnerManagersResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AvailableRunnerManager
 */
export class AvailableRunnerManager extends Message<AvailableRunnerManager> {
  /**
   * runner_manager_id is the unique identifier of the runner manager
   *
   * @generated from field: string runner_manager_id = 1;
   */
  runnerManagerId = "";

  /**
   * name is the human-readable name of the runner manager
   *
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * region is the region where the runner manager is located
   *
   * @generated from field: string region = 3;
   */
  region = "";

  constructor(data?: PartialMessage<AvailableRunnerManager>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AvailableRunnerManager";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_manager_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "region", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AvailableRunnerManager {
    return new AvailableRunnerManager().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AvailableRunnerManager {
    return new AvailableRunnerManager().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AvailableRunnerManager {
    return new AvailableRunnerManager().fromJsonString(jsonString, options);
  }

  static equals(a: AvailableRunnerManager | PlainMessage<AvailableRunnerManager> | undefined, b: AvailableRunnerManager | PlainMessage<AvailableRunnerManager> | undefined): boolean {
    return proto3.util.equals(AvailableRunnerManager, a, b);
  }
}

